import { matchRoutes } from 'react-router-dom';
import { useSharedGlobalState } from './useSharedGlobal';
export const useRouteTitle = ({ routesConfig, pathname = '', serverPageConfig = {}, }) => {
    const { isMenuUrlAddSystemName, system } = useSharedGlobalState();
    const _pathname = pathname || location.pathname;
    const _matchName = isMenuUrlAddSystemName
        ? _pathname
        : `${_pathname.replace(`/${system}`, '')}`;
    const _matchRoutes = matchRoutes(routesConfig, _matchName);
    const route = _matchRoutes?.[_matchRoutes?.length - 1]?.route;
    return (route?.title || serverPageConfig?.meta?.title || serverPageConfig?.name);
};
